import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { Farm, FarmCreate } from "@farm/domain/models/farm.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { RecuperableModelError } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class FarmCreateUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(farm: FarmCreate): Promise<Nullable<Farm>> {
        const createResult = await this.farmRepository.create(farm);

        return createResult.match(
            (farmCreated) => farmCreated,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
